import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

/** Native object selection preserves the original option passed to page callbacks. */
@Component({
  selector: 'app-option-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `<select [attr.aria-label]="label" [ngModel]="selected ?? null" [ngModelOptions]="{standalone: true}"
    (ngModelChange)="selectedChange.emit($event)" [disabled]="disabled">
    <option *ngIf="placeholder" [ngValue]="null" disabled>{{ placeholder }}</option>
    <option *ngFor="let option of options" [ngValue]="option">{{ option[labelKey] }}</option>
  </select>`,
  styles: [`:host { display: block; min-width: 0; }
    select { width: 100%; max-width: 100%; min-height: 40px; padding: 8px 28px 8px 12px; border: 1px solid var(--ia-border);
      border-radius: var(--ia-radius-sm); background: var(--ia-surface); color: var(--ia-text); font: inherit; cursor: pointer; }
    select:focus-visible { outline: 2px solid var(--ia-primary); outline-offset: 2px; }
    select:disabled { cursor: default; opacity: .6; }`]
})
export class OptionPickerComponent<T> {
  @Input() options: readonly T[] = [];
  @Input() selected: T;
  @Input() labelKey: keyof T;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() disabled = false;
  @Output() selectedChange = new EventEmitter<T>();
}
